<script lang="ts">
    import { onMount } from "svelte";
    import type { Location } from "../../../server";
    import type { Concert } from "../../../static";
    import Button from "../components/Button.svelte";
    import type { Action } from "svelte/action";

    interface Props {
        concert: Concert;
        onsubmit: (location: Location) => void;
    }

    let { concert, onsubmit }: Props = $props();

    const square: Action = (node) => {
        const resize = () => {
            const rect = node.parentElement!.getBoundingClientRect();
            const size = Math.min(rect.width, rect.height);
            node.style.width = `${size}px`;
            node.style.height = `${size}px`;
        };

        resize();

        window.addEventListener("resize", resize);

        return {
            destroy: () => window.removeEventListener("resize", resize),
        };
    };

    let location = $state<Location>();

    const onselectlocation = (e: PointerEvent) => {
        const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width;
        const y = (e.clientY - rect.top) / rect.height;
        location = { x, y };
    };

    onMount(() => {
        gtag("event", "page_view", { page_title: "LocationScreen" });
    });
</script>

<div class="flex flex-1 flex-col gap-[20px] p-[20px]">
    <img
        src={import.meta.env.VITE_STATIC_URL + concert.logoImage}
        alt=""
        class="h-[100px] object-contain object-center"
    />

    <h1 class="text-center text-lg font-semibold drop-shadow-md drop-shadow-black">
        Please tap where you are seated.
    </h1>

    <div class="relative flex flex-1 flex-shrink items-center justify-center">
        <div
            use:square
            class="pointer-events-auto absolute inset-0 m-auto bg-contain bg-center bg-no-repeat"
            style:background-image="url({import.meta.env.VITE_STATIC_URL}{concert.stageImages
                .audience})"
            onpointerdown={onselectlocation}
        >
            {#if location != null}
                <div
                    class="absolute size-[30px] rounded-[100%] border-[4px] border-white bg-blue-500"
                    style:top="calc({location.y * 100}% - 15px)"
                    style:left="calc({location.x * 100}% - 15px)"
                ></div>
            {/if}
        </div>
    </div>

    <Button onclick={() => onsubmit(location!)} disabled={location == null}>Confirm</Button>
</div>
